//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clientInvoiceStatusApi } from '@/api/enterprise';
import { getToken } from '@/utils/auth';
import { uploader } from '@/utils/uploadCloud';
export default {
  name: '',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      labelWidth: 100,
      imageUrl: '',
      uploadData: {},
      uploadSize: 5,
      myHeaders: {
        authorization: 'Bearer ' + getToken()
      },
      rules: {
        status: 1,
        invoice_type: 'mail',
        invoice_address: '',
        invoice_mail: '',
        collect_name: '',
        remark: '',
        collect_tel: '',
        file: ''
      },
      rule: {
        status: [{
          required: true,
          message: '请选择开票结果',
          trigger: 'change'
        }],
        invoice_type: [{
          required: true,
          message: '请选择发送方式',
          trigger: 'change'
        }],
        invoice_address: [{
          required: true,
          message: '请输入邮寄地址',
          trigger: 'blur'
        }],
        invoice_mail: [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        }],
        collect_name: [{
          required: true,
          message: '请输入联系人',
          trigger: 'blur'
        }],
        collect_tel: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'blur'
        }],
        remark: [{
          required: true,
          message: '请输入拒绝理由',
          trigger: 'blur'
        }]
      },
      loading: false
    };
  },
  computed: {
    propType: function propType() {
      if (this.rules.invoice_type == 'mail') {
        return 'invoice_mail';
      } else {
        return 'invoice_address';
      }
    }
  },
  watch: {
    config: {
      handler: function handler(nVal) {
        this.rules.invoice_type = nVal.data.collect_type;
        if (this.rules.invoice_type == 'mail') {
          this.rules.invoice_mail = nVal.data.collect_email;
        } else {
          this.rules.invoice_address = nVal.data.mail_address;
        }
        this.rules.collect_tel = nVal.data.collect_tel;
        this.rules.collect_name = nVal.data.collect_name;
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    openBox: function openBox() {
      this.dialogVisible = true;
    },
    handleConfirm: function handleConfirm() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this.rules.invoice_type == 'mail') {
            _this.rules.invoice_address = _this.rules.invoice_mail;
          }
          _this.loading = true;
          clientInvoiceStatusApi(_this.config.data.id, _this.rules).then(function (res) {
            _this.loading = false;
            _this.$emit('isOk');
            _this.handleClose();
          }).then(function (err) {
            _this.loading = false;
          });
        }
      });
    },
    // 上传文件方法
    uploadServerLog: function uploadServerLog(params) {
      var _this2 = this;
      var file = params.file;
      var options = {
        way: 2,
        relation_type: 'invoice',
        relation_id: this.config.data.id,
        eid: 0
      };
      uploader(file, 1, 2, options).then(function (res) {
        // 获取上传文件渲染页面
        if (res.name) {
          _this2.imageUrl = res.url;
          _this2.rules.file = res.attach_id;
        }
      }).catch(function (err) {});
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.rules = {
        status: 1,
        invoice_type: 'mail',
        collect_email: '',
        remark: '',
        collect_tel: '',
        collect_name: '',
        invoice_address: '',
        invoice_mail: '',
        file: ''
      };
      this.imageUrl = '';
    }
  }
};